import { validateEmail } from '../../utils/validateEmail'
import { hasLastName } from '../../utils/hasLastName'
import { validateCpf } from '../../utils/validateCpf'


export const isSummaryPrice = (price) =>
  Number.isFinite(price) && price >= 0.01 && price <= 999999.99

export const isPayLabelPrice = (price) => Number.isFinite(price) && price >= 0.01

export const isWalletPrice = (price) => typeof price === 'number' && price > 0

export const isSubmitDisabled = ({ method, isCardComplete, form }) => {
  if (!method) return true

  const missingContactData = !validateEmail(form.email) || !hasLastName(form.name)

  if (method === 'pix') return missingContactData || !validateCpf(form.cpf)

  if (method === 'boleto') {
    return !!(
      missingContactData ||
      !validateCpf(form.cpf) ||
      (form.zip || '').replace(/\D/g, '').length !== 8 ||
      !form.city ||
      !form.state ||
      !form.line1 ||
      !form.country
    )
  }

  return !!(
    !isCardComplete ||
    missingContactData ||
    (form.isBrazilResident && !validateCpf(form.cpf))
  )
}
